<template>
  <footer class="footer">
    <p>
      Todos os direitos Reservados © 2021. 
      Desenvolvido por
      <a href="http://www.codeduck.com.br" target="_blank">codeduck</a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>
